import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import './partModels.scss';

class PartModels extends Component {
  componentDidMount() {
    const {partCode} = this.props;
    this.props.getPartCarCompatibility(partCode);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.partCode !== this.props.partCode) {
      this.props.getPartCarCompatibility(this.props.partCode);
    }
  }

  renderTableBody() {
    const {models, loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='4'>
            <Loader active inline='centered'>
              Consultando los modelos compatibles del repuesto.
            </Loader>
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!models.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan='100%'>
            No hay datos disponibles
          </Table.Cell>
        </Table.Row>
      );
    }
  
    return models.map((partModel, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>{partModel.model}</Table.Cell>
          <Table.Cell>{partModel.katashiki}</Table.Cell>
          <Table.Cell>{partModel.brand}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <div className={`tde-part-models ${this.props.size}`}>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Modelo</Table.HeaderCell>
              <Table.HeaderCell>Katashiki</Table.HeaderCell>
              <Table.HeaderCell>Marca</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.renderTableBody()}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

PartModels.defaultProps = {
  'size': 'small',
};

const mapStateToProps = (state) => {
  return {
    'loading': state.partsMaster.loadingCompatibility,
    'models': state.partsMaster.compatibility,
  };
};

const {getPartCarCompatibility} = Actions;

export default connect(mapStateToProps, {getPartCarCompatibility})(PartModels);
